<template>
  <bottom-bar-layout class="mini-product-verify-detail"
                     :show-bar="true"
                     :bar-height="120"
                     :target-id="targetId"
                     :target-type="targetType"
                     is-show-share
  >
    <ym-img class="mini-product-verify-detail-cover"
            :src="cover"
    />
    <div class="mini-product-verify-detail-title">{{ title }}</div>
    <div class="mini-product-verify-detail-content"
         v-html="about"
    ></div>
    <!-- bottom bar -->
    <template #tabbar>
      <bottom-bar :benefit-bar="render.benefitBar"
                  :sell="sell"
                  :product="product"
                  :render-price="render.bottomBar.renderPrice"
                  :action-bar="render.bottomBar.actionBar"
                  :my-team-id="0"
                  @disabledJoin="handleDisabledJoin"
      />
    </template>
  </bottom-bar-layout>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import BottomBar from '@/components/ProductDetailBottom/Bar';
  import getMiniProductVerifyDetail from '@/services/mini-product-verify';
  import { getQuery } from '@/utils';

  export default {
    name: 'MiniProductVerifyDetail',
    metaInfo() {
      return {
        title: this.title,
      };
    },
    components: {
      BottomBarLayout,
      BottomBar,
    },
    data() {
      return {
        cover: '',
        title: '',
        about: '',
        sell: null,
        render: {
          bottomBar: null,
        },
      };
    },
    computed: {
      query() {
        return getQuery(this.$route.query);
      },
      targetId() {
        return parseInt(this.query.id, 10) || 0;
      },
      targetType() {
        return this.query.type || '';
      },
      product() {
        return {
          type: this.targetType,
          id: this.targetId,
          price: 99,
        };
      },
    },
    methods: {
      async fetchData() {
        const data = await getMiniProductVerifyDetail(this.targetType, this.targetId);
        this.cover = data.cover;
        this.about = data.about;
        this.title = data.title;
        this.sell = data.sell;
        this.render = data.render;
      },
      handleDisabledJoin() {
        this.fetchData();
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .mini-product-verify-detail {
    min-height: 100%;
    background: @color-white;

    &-cover {
      width: 100%;
    }
    &-title {
      box-sizing: border-box;
      width: 100%;
      margin: @size-base 0 @size-small 0;
      padding: 0 @size-base;
      color: @color-black-dark;
      font-size: @font-size-extra-extra-large;
      line-height: 1.5;
      font-weight: @font-weight-bold;
    }
    &-content {
      font-size: @font-size-base;
      color: @color-text-base;
      line-height: 1.4;
      background: @color-white;

      /deep/ img {
        width: 100%;
      }
    }
  }

</style>
